<template>
  <div>
    <PCMenu :memberSystem="company"/>
    <div class="m-auto w1200 main">
      <div class="wxpay">
        <div class="w">
          <!-- order 订单信息 -->
          <div class="order clearfix order-init order-init-oldUser-noQrcode">
            <!-- 订单信息 -->
            <div class="o-left" style="padding:20px 40px;">
              <h3 class="o-title">订单提交成功，请尽快付款！订单号：{{ orderId }}</h3>
            </div>
            <!-- 订单信息 end -->
            <!-- 订单金额 -->
            <div class="o-right" style="padding:20px 40px;">
              <div class="o-price"><em>应付金额</em><strong>{{ price }}</strong><em>元</em></div>
            </div>
            <!-- 订单金额 end -->
            <div class="o-list j_orderList" id="listPayOrderInfo">
              <!-- 单笔订单 -->

              <!-- 多笔订单 end -->
            </div>
          </div>
          <!-- order 订单信息 end -->

          <!-- payment 支付方式选择 -->
          <div class="payment">
            <!-- 微信支付 -->
            <div class="pay-weixin">
              <div class="p-w-hd">微信支付</div>
              <div class="p-w-bd" style="position:relative;"
                   :style="company.memberSystemId==116||company.memberSystemId==89?'zoom: 0.8;margin-top:-40px;':''">
                <!-- <div class="j_weixinInfo font-red" style="position:absolute; top: -36px; left: 130px;">二维码已过期，<a href="javascript:getWeixinImage2();">刷新</a>页面重新获取二维码。</div> -->
                <!-- <div class="j_weixinInfo" style="position:absolute; top: -36px; left: 130px;">距离二维码过期还剩<span class="j_qrCodeCountdown font-bold font-red">51</span>秒，过期后请刷新页面重新获取二维码。</div> -->
                <div class="p-w-box">
                  <div class="pw-box-hd">
                    <img id="weixinImageUrl" :src="qrCodeUrl" width="298" height="298">
                  </div>
                  <!-- <div class="pw-retry j_weixiRetry" style="display: block;">
                    <a class="ui-button ui-button-gray j_weixiRetryButton" href="javascript:getWeixinImage2();">获取失败 点击重新获取二维码 </a>
                  </div> -->
                  <div class="pw-error j_weixiError" style="display: none;"></div>
                  <div class="pw-box-ft">
                    <p>请使用微信扫一扫</p>
                    <p>扫描二维码支付</p>
                  </div>
                </div>
                <div class="p-w-sidebar"></div>
              </div>
            </div>
            <!-- 微信支付 end -->
            <!-- payment-change 变更支付方式 -->
            <!-- <div class="payment-change" id="return_weixin_jd">
              <a class="pc-wrap " onclick="window.history.go(-1)">
                <i class="pc-w-arrow-left">&lt;</i>
                <strong>选择其他支付方式</strong>
              </a>
            </div> -->
            <!-- payment-change 变更支付方式 end -->
          </div>
          <!-- payment 支付方式选择 end -->
        </div>
      </div>
    </div>
    <!--    <PCCopyright />-->
  </div>
</template>

<script>
import PCMenu from "@/components/PCMenu.vue";
import PCCopyright from "@/components/PCCopyright.vue";
import {Check_Order_Is_Paid, Reload_User_Info} from "@/api/index";

export default {
  name: "WxPay",
  components: {
    PCMenu,
    PCCopyright,
  },
  data() {
    return {
      qrCodeUrl:
          this.global.APIBasePath +
          "/Pay/NativeByCodeUrl?productId=" +
          this.$route.params.pId +
          "&orderNo=" +
          this.$route.params.no,
      orderId: this.$route.params.no,
      price: "",
      company: {},
      user: this.global.getUserInfo(),
      intervalId: 0
    };
  },
  methods: {
    loadOrderData() {
      let intervalId = +sessionStorage.getItem("intervalId") || 0;
      clearInterval(intervalId)
      var orderData = sessionStorage.getItem("OrderData");
      orderData = JSON.parse(orderData);
      this.price = orderData.price;
      this.orderId = orderData.no;
      this.global.getMemberSystem().then((memberSystem) => {
        if (!this.global.isNull(memberSystem)) {
          this.company = memberSystem;
        }
      });
      this.intervalId = setInterval(this.checkOrderIsPaid, 3000);
      sessionStorage.setItem("intervalId", this.intervalId);
    },
    checkOrderIsPaid: function () {
      Check_Order_Is_Paid({orderNo: this.orderId,notShowToast:true}).then(
          (data) => {
            if (data) {
              clearInterval(this.intervalId)
              Reload_User_Info().then(user => {
                user.memberSystemId=user.systemId
                localStorage.setItem("User", JSON.stringify(user));
                localStorage.setItem("AccessToken", user.accessToken);
                localStorage.setItem("RefreshToken", user.refreshToken);
                this.global.refreshToken(user.refreshToken);
                this.$router.push({path: "/pc"});
              })
            }
          }
      );
    },
  },
  mounted() {
    this.loadOrderData();
  },
  beforeDestroy() {
    clearInterval(this.intervalId)
  }
}
</script>
